import { translate } from '@/ui/i18n';

import styles from '../styles/TourOnTourSequences.module.css';
import { displayDecimal } from '../utils/display-scores.utils';

export function TourOnTourSequenceCard({
  name,
  eventCount,
  totalCo2,
  co2PerDate,
  datesImpact,
  travelsImpact,
  accommodationImpact,
  cateringImpact,
  equipmentImpact,
}: {
  name: string;
  eventCount: number;
  totalCo2: number;
  co2PerDate: number;
  datesImpact: number;
  travelsImpact: number;
  accommodationImpact: number;
  cateringImpact: number;
  equipmentImpact: number;
}) {
  const teCO2 = translate('Projects.teCO2');

  return (
    <div className={styles.card}>
      <div className={styles.cardHeader}>
        <span className={styles.cardTitle}>{name}</span>
        <span className={styles.headerTotal}>
          {displayDecimal(totalCo2)}{' '}
          <span className={styles.headerTotalUnit}>{teCO2}</span>
        </span>
      </div>
      <div className={styles.cardBody}>
        <div className={styles.primary}>
          <div className={styles.stat}>
            <div className={styles.statValue}>{eventCount}</div>
            <div className={styles.statLabel}>
              {translate('ProjectsTour.dates')}
            </div>
          </div>
          <div className={styles.stat}>
            <div className={styles.statValue}>
              {displayDecimal(totalCo2)}{' '}
              <span className={styles.statUnit}>{teCO2}</span>
            </div>
            <div className={styles.statLabel}>
              {translate('ProjectsTour.emited')}
            </div>
          </div>
          <div className={styles.stat}>
            <div className={styles.statValue}>
              {displayDecimal(co2PerDate)}{' '}
              <span className={styles.statUnit}>{teCO2}</span>
            </div>
            <div className={styles.statLabel}>
              {translate('ProjectsTour.emited-by-date')}
            </div>
          </div>
        </div>
        <div className={styles.secondary}>
          <BreakdownGroup
            title={translate('ProjectsTour.OnTour.travels-and-dates')}
            items={[
              { label: translate('ProjectsTour.dates'), value: datesImpact },
              {
                label: translate('ProjectsTour.travels'),
                value: travelsImpact,
              },
            ]}
          />
          <BreakdownGroup
            title={translate('ProjectsTour.various-cost')}
            items={[
              {
                label: translate('Co2.Sections.ACCOMMODATION'),
                value: accommodationImpact,
              },
              {
                label: translate('Co2.Sections.CATERING'),
                value: cateringImpact,
              },
              {
                label: translate('Co2.Sections.EQUIPMENT'),
                value: equipmentImpact,
              },
            ]}
          />
        </div>
      </div>
    </div>
  );
}

function BreakdownGroup({
  title,
  items,
}: {
  title: string;
  items: { label: string; value: number }[];
}) {
  return (
    <div className={styles.group}>
      <div className={styles.groupTitle}>{title}</div>
      {items.map(({ label, value }) => (
        <div className={styles.breakdownRow} key={label}>
          <span className={styles.breakdownLabel}>{label}</span>
          <span className={styles.breakdownValue}>
            {displayDecimal(value)}{' '}
            <span className={styles.breakdownUnit}>
              {translate('Projects.teCO2')}
            </span>
          </span>
        </div>
      ))}
    </div>
  );
}
